<template>
  <v-autocomplete
    v-model="filterObject"
    :placeholder="$t('labels.savedFilters')"
    :items="filters"
    item-text="name"
    item-value="meta"
    single-line
    hide-details
    hide-no-data
    @input="onSelected"
    :loading="loading"
    v-if="filters.length > 0"
  >
    <template v-slot:item="{ item }">
      <v-list-item-content>
        <v-list-item-title v-html="item.name"></v-list-item-title>
      </v-list-item-content>
      <v-list-item-action>
        <v-btn icon @click="doDelete(item)">
          <v-icon small>{{ $vuetify.icons.values.trash }}</v-icon>
        </v-btn>
      </v-list-item-action>
    </template>
  </v-autocomplete>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { NAMESPACE } from '@argon/app/store'

export default {
  name: 'SearchSelector',
  props: {
    context: { type: String, required: true }
  },
  data: () => ({
    filterName: null,
    loading: false,
    filterObject: null
  }),
  computed: {
    ...mapState(NAMESPACE, ['filters'])
  },
  methods: {
    ...mapActions(NAMESPACE, ['listSavedFilters', 'deleteSavedFilter', 'setAppliedFilter']),
    onSelected(filterObject) {
      this.setAppliedFilter({ context: this.context, filterObject }).then(() => {
        this.filterObject = null
      })
    },
    doDelete(item) {
      this.loading = true
      this.deleteSavedFilter({ context: this.context, filterId: item.id }).then(() => {
        this.filterName = null
        this.loading = false
      })
    }
  },
  created() {
    this.loading = true
    this.listSavedFilters(this.context).then(() => {
      this.filterName = null
      this.loading = false
    })
  }
}
</script>

<style scoped>
.v-text-field {
  padding-top: 0;
  margin-top: 8px;
  margin-bottom: 20px;
}
</style>
